import { customStyled, Text } from '@mafc/trolly';
import COLORS from 'theme/colors';

export const OOSTag = customStyled(Text.Caption)<{ isCompact?: boolean }>(props => {
  let sizeProps = {};
  if (props.isCompact) {
    sizeProps = { padding: '2px', minWidth: 'auto', whiteSpace: 'nowrap' };
  }
  return {
    color: COLORS.C4RED,
    backgroundColor: props.theme.colors.error,
    padding: '2px 6px',
    fontWeight: props.theme.fontWeights[6],
    fontSize: props.theme.fontSizes[0],
    minWidth: '76px',
    lineHeight: '10px',
    ...sizeProps,
  };
});
